import axios from "axios";
import { tokenConfig } from "@/helpers/auth";

export default {
  state() {
    return {
      activity: [],

      nextUrl: null,
      isLoadingActivity: false,
    };
  },

  getters: {},

  mutations: {
    refreshActivity(state, payload) {
      state.activity = payload.results;

      if (process.env.NODE_ENV === "production") {
        state.nextUrl = payload.next;
      } else {
        if (payload && payload.next) state.nextUrl = payload.next.slice(21);
        else state.nextUrl = null;
      }
    },

    setIsLoadingActivity(state, payload = null) {
      state.isLoadingActivity = payload;
    },

    updateActivity(state, payload) {
      if (process.env.NODE_ENV === "production") {
        state.nextUrl = payload.next;
      } else {
        if (payload && payload.next) state.nextUrl = payload.next.slice(21);
        else state.nextUrl = null;
      }

      state.activity.push(...payload.results);
    },
  },

  actions: {
    getActivity({ dispatch, commit, rootState }, branchId) {
      return new Promise((resolve, reject) => {
        commit("setIsLoadingActivity", true);
        axios
          .get(
            `/api/v1/branches/activity/${branchId}/branch_activity/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setBranchNotFound", false);
            commit("refreshActivity", response.data);

            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setBranchNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          })
          .finally(() => {
            commit("setIsLoadingActivity", false);
          });
      });
    },

    moreActivity({ dispatch, commit, rootState, state }) {
      return new Promise((resolve, reject) => {
        if (state.nextUrl) {
          commit("setIsLoadingActivity", true);

          axios
            .get(state.nextUrl, tokenConfig(rootState))
            .then((response) => {
              commit("updateActivity", response.data);

              resolve(response);
            })
            .catch((error) => {
              dispatch("handleError", error);
              reject(error);
            })
            .finally(() => {
              commit("setIsLoadingActivity", false);
            });
        }
      });
    },
  },
};
